import { BaseRouteService } from 'core/services';

class TeamsRouteService extends BaseRouteService {
    constructor() {
        super('teams');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,embed,fields,userId,isActive}', filter);
    }

    get(id, options) {
        return super.get(this.base + '/{id}/{?embed,fields}', id, options);
    }

    create(resource) {
        return super.create(this.base, resource);
    }

    update(resource) {
        return super.update(this.base + '/{id}', resource);
    }

    delete(resource) {
        return super.delete(this.base + '/{id}', resource);
    }

    createTeamUser(resource) {
        return super.create(this.base + '/user', resource);
    }

    deleteTeamUser(resource) {
        return super.delete(this.base + '/user', resource);
    }

    deleteTeamUsers(resource) {
        return super.delete(this.base + '/users/{userId}', resource);
    }
}

export default TeamsRouteService;
